import { InjectionToken } from '@angular/core';

import { BAAS_TOAST_PORT } from '@lvflanders/bar-ui';

export const BAR_UI_BUNDLE_LOADED = new InjectionToken<boolean>('BAAS_UI_BUNDLE_LOADED', {
    providedIn: 'root',
    factory: () => {
        try {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            BAAS_TOAST_PORT;
            return true;
        } catch {
            console.error(
                'BAAS_TOAST_PORT token is undefined. The @lvflanders/bar-ui bundle is either not loaded or loaded in the wrong order. Ensure it is registered after the @lvflanders/bar bundle.'
            );
            return false;
        }
    }
});
